import React from "react";
import { cn } from "./utils";

export const Table = React.forwardRef(({ className, ...props }, ref) => (
  <div className="tw-relative tw-w-full tw-overflow-x-auto">
    <table ref={ref} className={cn("tw-m-0 tw-w-full tw-caption-bottom tw-border-collapse tw-font-sans tw-text-sm", className)} {...props} />
  </div>
));
Table.displayName = "Table";

export const TableHeader = ({ className, ...props }) => (
  <thead className={cn("tw-bg-muted/60 [&_tr]:tw-border-b", className)} {...props} />
);

export const TableBody = ({ className, ...props }) => (
  <tbody className={cn("[&_tr:last-child]:tw-border-0", className)} {...props} />
);

export const TableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr ref={ref} className={cn("tw-border-b tw-transition-colors", className)} {...props} />
));
TableRow.displayName = "TableRow";

// Rows that open something: hover tint, pointer, visible keyboard focus.
export const clickableRow =
  "tw-cursor-pointer hover:tw-bg-accent/60 focus-visible:tw-bg-accent/60 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-inset focus-visible:tw-ring-ring";

export const TableHead = ({ className, ...props }) => (
  <th
    className={cn(
      "tw-h-9 tw-whitespace-nowrap tw-px-3 tw-text-left tw-align-middle tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-muted-foreground",
      className,
    )}
    {...props}
  />
);

export const TableCell = ({ className, ...props }) => (
  <td className={cn("tw-whitespace-nowrap tw-px-3 tw-py-2.5 tw-align-middle tw-text-foreground", className)} {...props} />
);
